<script>import { getComponentsContext } from "../contexts";
import Children from "./Children.svelte";
export let astNode;
export let __index = 0;
export let type = void 0;
export let position = void 0;
type && position;
const components = getComponentsContext();
</script>

{#if astNode.type === 'root'}
	<Children {...astNode} />
{:else if astNode.type === 'element'}
	<svelte:component
		this={$components[astNode.tagName]}
		{...astNode}
		{__index}
	/>
{:else if $components[astNode.type] !== undefined}
	<svelte:component this={$components[astNode.type]} {...astNode} {__index} />
{/if}
